export default {"src":"/_next/static/media/turkey-outline-icon.df36937b.svg","height":34,"width":45,"blurWidth":0,"blurHeight":0};